import { RootState } from "App/Store";

import { IManualDeliveries } from "Types/EVaultAppTypes";

export function getIncomingDeliveries(state: RootState): IManualDeliveries {
  return state.incomingDeliveries;
}
